import {Source} from "@common-core/coat-operational-hierarchy-appsync-model";

export const toCacmSource = (sourceId: string): Source => ({
  sourceId,
  sourceType: "CACM"
});
